import Layout from '../components/layouts'
import Comprobantes from '../components/modules/views/dashboard/MiContador/Comprobantes'
// import BloqueDePeriodos from '../components/modules/views/dashboard/MiContador/BloqueoPeriodo/BloqueDePeriodos'
import Tabs from '../components/modules/tabs/Tabs'
//import TraspasoDeApertura from '../components/modules/views/dashboard/MiContador/TraspadoApertura/TraspasoDeApertura'

const MiContador = () => {
  const data = [
    {
      title: 'Comprobantes',
      content: <Comprobantes />,
    },
    // {
    //   title: 'Bloqueo de Períodos',
    //   content: <BloqueDePeriodos />,
    // },
    /*{
      title: 'Traspaso de Apertura',
      content: <TraspasoDeApertura />,
    },*/
  ]

  return (
    <Layout className="px-4 md:px-8">
      <div>
        <Tabs tabs={data}/>
      </div>
    </Layout>
  )
}

export default MiContador
